<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" :md="10" :lg="8">
                <el-card class="box" shadow="always">
                    <h2 style="margin-bottom: 30px;">欢迎回来，{{userName}}!</h2>
                    <el-table :data="historyData" :show-header="false">
                        <el-table-column prop="value">
                            <template slot-scope="scope">
                                <el-tag size="small" :type="scope.row.type">{{scope.row.value}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="name" prop="name"></el-table-column>
                    </el-table>
                </el-card>
            </el-col>

            <el-col :span="24" :md="14" :lg="16">
                <el-card class="box" shadow="always">
                    <div style="margin-bottom: 20px;">
                        <el-radio-group size="mini" @change="getChartData" v-model="chartDateType">
                            <el-radio-button label="day">24小时</el-radio-button>
                            <el-radio-button label="month">30日</el-radio-button>
                            <el-radio-button label="year">12月</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div class="chart" ref="chart" style="height:310px; width: 100%"></div>
                </el-card>
            </el-col>

            <el-col :span="24" :md="24" :lg="24">
                <el-card class="box" shadow="always" style="height: auto">
                    <el-tabs v-model="activeName">
                        <el-tab-pane label="交易日志" name="first">
                            <div class="searchHead">
                                <div class="name">交易日志记录 （共{{(total1)}}条)</div>
                                <div class="filter">
                                    <el-input style="width:150px;margin-right: 5px" placeholder="发送方ID" size="small" v-model="senderId"/>
                                    <el-input style="width:150px;margin-right: 5px" placeholder="接收方ID" size="small" v-model="receiverId"/>
                                    <el-select style="width:150px;margin-right: 5px" size="small" v-model="status1">
                                        <el-option label="全部" value=""></el-option>
                                        <el-option label="成功" value="Success"></el-option>
                                        <el-option label="失败" value="Failed"></el-option>
                                        <el-option label="处理中" value="Executing"></el-option>
                                    </el-select>
                                    <el-button icon="el-icon-search" size="small" type="primary" @click="pageNum1=1;total1=1;getTableData1()"></el-button>
                                </div>
                            </div>
                            <el-table v-loading="tableLoading1" :data="tableData1" :default-sort='{ prop: "date",order: "descending"}'>
                                <el-table-column label="日期/时间" prop="createTime" width="170px"></el-table-column>
                                <el-table-column label="状态" prop="status" width="80px">
                                    <template slot-scope="scope">
                                        <div>
                                            <span v-if='"成功" === scope.row.status' style='display: flex; align-items: center;'>
                                                <div :style='{
                                                    height: "10px",
                                                    width: "10px",
                                                    "border-radius": "50%",
                                                    border: "1px solid #fff",
                                                    outline: "1px solid #fff",
                                                    background: "#06d806",
                                                    marginRight: "5px",
                                                }'/>
                                                成功
                                            </span>
                                            <span v-else-if='"失败" === scope.row.status'>
                                                <div :style='{
                                                    display: "inline-block",
                                                    "margin-right": "3px",
                                                    height: "10px",
                                                    width: "10px",
                                                    "border-radius": "50%",
                                                    border: "1px solid #fff",
                                                    outline: "1px solid #fff",
                                                    background: "red"
                                                }'/>
                                                失败
                                            </span>
                                            <span v-else-if='"处理中" === scope.row.status'>
                                                <div :style='{
                                                    display: "inline-block",
                                                    "margin-right": "3px",
                                                    height: "10px",
                                                    width: "10px",
                                                    "border-radius": "50%",
                                                    border: "1px solid #fff",
                                                    outline: "1px solid #fff",
                                                    background: "#ccc"
                                                }'/>
                                                处理中
                                            </span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="发送方" prop="senderId" width="130px"></el-table-column>
                                <el-table-column label="接收方" prop="receiverId" width="130px"></el-table-column>
                                <el-table-column label="方向" prop="direction" width="80px"></el-table-column>
                                <el-table-column label="协议类型" prop="protocolType"  width="80px"></el-table-column>
                                <el-table-column label="实例标识" prop="instanceId"></el-table-column>
                                <el-table-column label="报文内容" prop="payload" width="100px">
                                    <template slot-scope="scope">
                                        <el-link type="primary" @click="getContent(scope.row.payload)">查看内容</el-link>
                                    </template>
                                </el-table-column>
                                <el-table-column label="回执内容" prop="mdnPayload" width="120px">
                                    <template slot-scope="scope">
                                        <el-link type="primary" @click="getContent(scope.row.mdnPayload)">查看内容</el-link>
                                    </template>
                                </el-table-column>
                                <el-table-column label="文件名" prop="fileName"></el-table-column>
                            </el-table>

                            <el-pagination
                                style="padding: 20px 0; text-align: right;"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total1"
                                :page-size="pageSize1"
                                :page-sizes="[10, 20, 30, 50, 100, 200]"
                                :current-page="pageNum1"
                                @current-change="handleNoChange"
                                @size-change="handleSizeChange"
                            ></el-pagination>
                        </el-tab-pane>
                    </el-tabs>
                </el-card>
            </el-col>
        </el-row>

        <el-dialog
            :visible.sync="showDialog"
            title="报文内容"
            @close="handleDialogClose"
        >
            <pre v-loading="contentLoading" class="line" style="min-height: 300px; white-space: pre-wrap;" v-html="content"></pre>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'HOME',
    data: function() {
        return {
            userName: localStorage.getItem("ediUsername"),
            myChart: null,
            chartLoading: !1,
            activeName: "first",
            tableLoading2: !1,
            tableData2: [],
            pageNum1: 1,
            pageSize1: 10,
            senderId: "",
            receiverId: "",
            total1: 0,
            query1: "",
            status1: "",
            tableLoading1: !1,
            tableData1: [],
            historyData: [{
                type: "info",
                name: "合作伙伴",
                prop: "partnerCount",
                value: "-"
            }, {
                type: "info",
                name: "报文",
                prop: "transactionCount",
                value: "-"
            }, {
                type: "info",
                name: "今日交易",
                prop: "transactionByTodayCount",
                value: "-"
            }, {
                type: "success",
                name: "发送成功",
                prop: "sendCount",
                value: "-"
            }, {
                type: "success",
                name: "接收成功",
                prop: "receiveCount",
                value: "-"
            }, {
                type: "danger",
                name: "失败",
                prop: "failCount",
                value: "-"
            }],
            chartDateType: "day",
            showDialog: !1,
            contentLoading: !1,
            content: ""
        }
    },
    methods: {
        getContent: function(t) {
            this.content = ''; // 重置内容
            this.showDialog = true;
            this.content = t && t.trim() ? t.trim() : '无内容';
        },
        handleDialogClose() {
            this.content = '';
            this.showDialog = false;
        },
        setOptions: function(t) {
            const echarts = require('echarts')
            const e = t.time
                , n = t.send
                , i = t.receive
                , r = t.fail;
            if (this.myChart) {
                this.myChart.dispose();
            }
            this.myChart = echarts.init(this.$refs.chart);
            const o = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["发送成功", "接收成功", "失败"],
                    icon: "rect",
                    right: 20,
                    top: 0
                },
                grid: {
                    right: "30",
                    left: "30",
                    bottom: "0%",
                    top: "30",
                    containLabel: !0
                },
                xAxis: {
                    type: "category",
                    boundaryGap: !1,
                    data: e
                },
                yAxis: {
                    type: "value"
                },
                series: [{
                    name: "发送成功",
                    prop: "send",
                    itemStyle: {
                        color: "rgb(101, 149, 180)"
                    },
                    smooth: !0,
                    type: "line",
                    data: n
                }, {
                    name: "接收成功",
                    prop: "receive",
                    itemStyle: {
                        color: "rgb(126,157,58)"
                    },
                    smooth: !0,
                    type: "line",
                    data: i
                }, {
                    name: "失败",
                    prop: "fail",
                    itemStyle: {
                        color: "rgb(169,68,66)"
                    },
                    smooth: !0,
                    type: "line",
                    data: r
                }]
            };
            this.myChart.setOption(o)
        },
        getTodayCount: function() {
            var t = this;
            this.$http.get("/transactionLog/getOverview").then((function(e) {
                    t.historyData.forEach((function(t) {
                            var n = t.prop;
                            t.value = e.data[n] || 0
                        }
                    ))
                }
            ))
        },
        getChartData: function() {
            var t = this.chartDateType;
            switch (t) {
                case "day":
                    this.getReportData(24);
                    break;
                case "week":
                    break;
                case "month":
                    this.getReportData(30);
                    break;
                case "year":
                    this.getReportData(12);
                    break;
                default:
                    return
            }
        },
        onWindowResize: function() {
         
        },
        getReportData: function(t) {
            const e = this;
            this.chartLoading = !0
                this.$http.get("/transactionLog/getReport/" + t).then((function(t) {
                        e.setOptions(t.data)
                    }
                )).finally((function() {
                        e.chartLoading = !1
                    }
                ))
        },
        getTableData1: function() {
            const t = this;
            this.$http.get("/transactionLog/getTotalCount", {
                params: {
                    senderId: this.senderId,
                    receiverId: this.receiverId,
                    status: this.status1
                }
            }).then(res => {
                t.total1 = res.data
            })
            this.tableLoading1 = !0
                this.$http.get("/transactionLog/getList", {
                    params: {
                        pageNo: this.pageNum1,
                        pageSize: this.pageSize1,
                        senderId: this.senderId,
                        receiverId: this.receiverId,
                        status: this.status1
                    }
                }).then((function(e) {
                        t.tableData1 = e.data
                    }
                )).finally((function() {
                        t.tableLoading1 = !1
                    }
                ))
        },
        handleSizeChange: function (newSize) {
            this.pageSize1 = newSize;
            this.getTableData1()
        },
        handleNoChange: function (newNo) {
            this.pageNum1 = newNo;
            this.getTableData1()
        }
    },
    destroyed: function() {
        window.onresize = null
            this.myChart = null
    },
    mounted: function() {
        window.onresize = this.onWindowResize.bind(this),
        this.getChartData()
        this.getTodayCount()
        this.getTableData1()
    }
}

</script>
<style lang="scss" scoped>
.tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 5px
}

.company-desc {
    position: absolute;
    bottom: 37%;
    left: 43%;
    font-size: 12px;
    color: #cbeae4
}


test{
    height: 100vh;
    background-image: linear-gradient(0deg,#1e3c72 0,#1e3c72 1%,#2a5298)
}

.login-container .title {
    font-size: 26px;
    font-weight: 400;
    color: #2033b3;
    margin: 0 auto 40px;
    text-align: center;
    font-weight: 700;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.login-container .login-form {
    position: absolute;
    left: 0;
    right: 0;
    top: 7%;
    z-index: 2;
    width: 382px;
    padding: 35px 35px 15px;
    margin: 120px auto;
    background-color: #fff;
    border-radius: 5px
}

.box {
    height: 400px;
    margin: 10px 0
}

.searchHead {
    display: flex;
    padding: 10px;
    justify-content: space-between;
    align-items: center
}

.line {
    line-height: 1.7;
    font-size: 14px;
    color: #666
}

</style>
